﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListEn extends GuiListGeneric {

    constructor() {
        super("Entsorgungsnachweis");

    }

}

